import { Box } from '@mui/material';
import { debounce, isArray, isEmpty, toLower, toString, xor } from 'lodash';
import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { IFilterOption } from 'src/interfaces';

import { CheckboxListProps } from './CheckboxList.interface';
import {
  CheckboxField,
  Label,
  SearchBar,
  Wrapper,
} from './CheckboxList.styled';

export const Checkbox = ({
  option,
  props,
}: {
  option: IFilterOption;
  props: CheckboxListProps;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = xor(
      props.selectedOptions,
      toString(event.target.value).split(','),
    );
    props.onChange(props.summaryLabel, newValue);
  };

  const isChecked =
    isArray(option.value) && !isEmpty(option.value)
      ? option.value.some((item) => props.selectedOptions.includes(item))
      : props.selectedOptions.includes(toString(option.value));

  return (
    <CustomTooltip
      width={500}
      placement="right"
      title={option.label}
      overflowLineNumber={1}
      renderChildren={(ref, style) => (
        <Label
          control={
            <CheckboxField
              checked={isChecked}
              onChange={handleChange}
              name={option.label}
              color="primary"
              value={option.value}
            />
          }
          label={
            <div ref={ref} style={style}>
              {option.label}
            </div>
          }
        />
      )}
    />
  );
};

export const CheckboxList = (props: CheckboxListProps) => {
  const [searchVal, setSearchVal] = useState('');
  const [debouncedSearchVal, setDebouncedSearchVal] = useState('');

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event?.target?.value ?? '';
    setSearchVal(value);
    debouncedUpdateSearch(value);
  };

  const debouncedUpdateSearch = debounce(
    (value: string) => setDebouncedSearchVal(value),
    500,
  );

  const filteredOptions =
    !props.searchable || isEmpty(debouncedSearchVal)
      ? props.options
      : props.options.filter((option) =>
          toLower(option.label).includes(toLower(debouncedSearchVal)),
        );

  useEffect(() => {
    if (props.resetVal) {
      setSearchVal('');
      setDebouncedSearchVal('');
      props.setResetVal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.resetVal]);

  return (
    <Wrapper>
      {props.searchable && (
        <SearchBar value={searchVal} onChange={onSearchChange} />
      )}

      {filteredOptions.map((option, i) => (
        <Checkbox key={i} option={option} props={props} />
      ))}
      <InView
        as="div"
        onChange={(inView) => {
          if (inView && props.currPage < props.totalPages) {
            props.updatePage(props.currPage + 1);
          }
        }}>
        <Box bgcolor={'red'}></Box>
      </InView>
    </Wrapper>
  );
};
